$(function () {
  $( ".accordion" ).accordion({
  	header: ".page-group-link",
  	heightStyle: "content",
  	collapsible: true,
  	active: false
  });
});